<template>
    <div>
        <div>
            <CRow>
                <CCol>
                    <hr />
                    <div>
                        <div>archivosSubir: {{archivosSubir}}</div>
                        <div>empresa: {{empresa}}</div>
                        <div>tipoDocumentoSelected: {{tipoDocumentoSelected}}</div>
                        <div>mesSelected: {{mesSelected}}</div>
                        <div>periodoSelected: {{periodoSelected}}</div>
                        <div>mostrarPeriodo: {{mostrarPeriodo}}</div>
                        <div>mostrarSubirDocumentos: {{mostrarSubirDocumentos}}</div>
                        <div></div>
                        <pre>{{ JSON.stringify(archivosSubir, null, 2) }}</pre>

                        <file-upload
                            class="btn btnPrincipalVapp mr-2"
                            ref="upload"
                            v-model="archivosSubir"
                            :post-action="null"
                            :extensions="configFileUpload.extensions"
                            :accept="configFileUpload.accept"
                            :directory="configFileUpload.directory"
                            :size="configFileUpload.size || 0"
                            :headers="configFileUpload.headers"
                            :multiple="configFileUpload.multiple"
                            :thread="configFileUpload.thread < 1 ? 1 : configFileUpload.thread > 5 ? 5 : configFileUpload.thread"
                            :drop="configFileUpload.drop"
                            :drop-directory="configFileUpload.dropDirectory"
                            :add-index="configFileUpload.addIndex"
                            @input-file="inputFile"
                        >
                            <CIcon :name="$utils.iconosGenerales('agregar')" />
                            Agregar Archivos
                        </file-upload>
     
                        <p v-if="archivosSubir.length === 0">No hay archivos</p>
                            <ul v-else>
                            <li v-for="archivo in archivosSubir" :key="archivo.id">
                                {{ archivo.name }} - {{ archivo.size }} bytes
                            </li>
                            </ul>

                        <button
                            v-show="archivosSubir.length > 0"
                            style="font-size: 11px"
                            type="button"
                            class="btn btnPrincipalVapp mr-2"
                            v-if="!$refs.upload || !subidaTodoActiva"
                            @click.prevent="subirTodosLosArchivos()"
                        >
                        <CIcon :content="$options.freeSet.cilCloudUpload" />
                        Subir todo
                        </button>

                        
                        <button
                            style="font-size: 11px"
                            type="button"
                            class="btn btn-danger mr-2"
                            v-else
                            @click.prevent="subidaTodoActiva = false"
                        >
                            <CIcon :content="$options.freeSet.cilXCircle" />
                            Detener todo
                        </button>

                        <button
                            style="font-size: 11px"
                            v-show="archivosSubir.length > 0 && !isLoadingSubir"
                            type="button"
                            class="btn btn-danger mr-2 ml-2"
                            @click.prevent="archivosSubir = []"
                        >
                        <CIcon :name="$utils.iconosGenerales('quitar')" />
                        Quitar Documentos
                        </button>
                        |
                        <button
                            style="font-size: 11px"
                            type="button"
                            class="btn btnPrincipalVapp ml-2"
                            @click.prevent="archivosSubir = []; cerrarSubirDocumentos()"
                        >
                            <CIcon :content="$options.freeSet.cilBan" />
                            Cerrar subir Documentos
                        </button>
                    </div>
                    <div class="mt-2">
                        <div v-for="(archivo, index) in archivosSubir" :key="archivo.id || archivo.name">
                            <CCard class="mb-2">
                                <CCardHeader>
                                    <CRow>
                                        <CCol sm="9" md="9" lg="9">
                                            <CRow>
                                                <CCol class="text-center">({{ archivo.size | prettyBytes }}) {{ archivo.name }}</CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol class="text-center">
                                                    <span v-if="archivo.error" style="color: #7e1146">
                                                        <span v-if="archivo.error === 'size'">
                                                            Archivo demasiado pequeño
                                                        </span>
                                                        <span v-else> {{ validarMensaje(archivo) }} </span>
                                                    </span>
                                                    <span v-else-if="archivo.success" style="color: #2eb85c">
                                                        {{ archivo.response.mensaje }}
                                                    </span>
                                                    <CBadge v-else-if="archivo.active && parseInt(archivo.progress) < 100" color="warning">
                                                        Subiendo
                                                    </CBadge>
                                                    <CBadge v-else-if="archivo.active && parseInt(archivo.progress) === 100" color="warning">
                                                        Procesando archivo ...
                                                    </CBadge>

                                                    <CBadge v-else color="secondary"> En espera </CBadge>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol class="center-content">
                                                    <CProgress style="width: 50%;"
                                                        :value="parseFloat(archivo.progress)"
                                                        :precision="2"
                                                        show-percentage
                                                        :animated="true"
                                                        :color="archivo.error ? 'danger' : 'success'"
                                                        />
                                                        <span class="ml-1">{{ archivo.speed | prettyBytes }}/s</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol sm="3" md="3" lg="3" class="d-flex justify-content-center align-items-center">
                                            <CButtonGroup class="mx-1">
                                                <CButton
                                                    v-if="archivo.active"
                                                    title="Cancelar subida archivo"
                                                    color="danger"
                                                    size="sm"
                                                    @click.prevent="
                                                    archivo.active
                                                        ? $refs.upload.update(archivo, { error: 'Cancelado' })
                                                        : false
                                                    "
                                                >
                                                    <CIcon name="cil-x-circle" />
                                                </CButton>

                                                <CButton
                                                    v-else-if="
                                                    archivo.error &&
                                                    archivo.error !== 'compressing' &&
                                                    $refs.upload.features.html5
                                                    "
                                                    title="Recargar archivo"
                                                    color="info"
                                                    size="sm"
                                                    @click.prevent="recargarArchivo(archivo)"
                                                >
                                                    <CIcon :content="$options.freeSet.cilLoopCircular" />
                                                </CButton>

                                                <CButton
                                                    v-else
                                                    title="Subir archivo"
                                                    color="success"
                                                    size="sm"
                                                    :disabled="archivo.success"
                                                    @click.prevent="
                                                    archivo.success || archivo.error === 'compressing'
                                                        ? false
                                                        : subirArchivo(archivo)
                                                    "
                                                >
                                                    <CIcon :content="$options.freeSet.cilCloudUpload" />
                                                </CButton>

                                                <CButton
                                                    title="Quitar archivo"
                                                    color="danger"
                                                    size="sm"
                                                    v-show="!archivo.active"
                                                    @click.prevent="
                                                    archivo.active ? false : $refs.upload.remove(archivo)
                                                    "
                                                >
                                                    <CIcon :content="$options.freeSet.cilTrash" />
                                                </CButton>
                                            </CButtonGroup>
                                        </CCol>
                                    </CRow>

                                </CCardHeader>
                            </CCard>
                        </div>
                    </div>
                    

                    <hr />
                </CCol>
            </CRow>
            
        </div>
    
    </div>
</template>

<script>
    import cons from '@/const'
    import { freeSet } from "@coreui/icons";
    import axios from "axios"

    import FileUpload from "vue-upload-component";

export default {
  name: "subidaDocumentos",
  freeSet,
  components: {
    FileUpload,
  },
  props: {
    empresa: Object,
    tipoDocumentoSelected: Object,
    mesSelected: Object,
    periodoSelected: Object,
    mostrarPeriodo: Boolean,
    mostrarSubirDocumentos: Boolean,
  },
  data () {
    return {
        urlBase: cons.port+"://" + cons.ipServer,
        tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                
        subidaTodoActiva: false,
        archivosSubir: [],
        isLoadingSubir: false,
      /* subir archivos*/
      columnasSubidaArchivos: [
          { title: 'Nombre Archivo', scopedSlots: { customRender: 'nombreArchivo' }, width: '20%', align: 'left' ,ellipsis: false},
          { title: 'Progreso', scopedSlots:{ customRender: 'progreso' }, width: '20%', align: 'center', ellipsis: false},
          { title: 'Tamaño', scopedSlots: { customRender: 'tamanio' }, width: '10%', align: 'left', ellipsis: false},
          { title: 'Velocidad', scopedSlots: { customRender: 'velocidad' }, width: '10%', align: 'center', ellipsis: false},
          { title: 'Estado', scopedSlots: { customRender: 'estado' }, width: '20%', align: 'center', ellipsis: false},
          { title: 'Acciones', scopedSlots: { customRender: 'acciones' }, width: '20%', align: 'center', ellipsis: false},
      ],

      configFileUpload: {
        accept: "*",
        extensions: "",
        minSize: 1024,
        size: 0,
        multiple: true,
        directory: false,
        drop: true,
        dropDirectory: true,
        addIndex: false,
        thread: 3,
        name: "file",
        postAction: "",//cons.port+":" + cons.ipServer + "/upload_file",
        putAction: "",
        headers: {
            Authorization: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
        },
        data: {
            _csrf_token: "xxxxxx",
        },
        autoCompress: 1024 * 1024,
        uploadAuto: false,
        isOption: false,
      },

      addData: {
          show: false,
          name: "",
          type: "",
          content: "",
      },
      editFile: {
          show: false,
          name: "",
      },
    }
  },
  watch: { 
        /*"editFile.show"(newValue, oldValue) {
            if (!newValue && oldValue) {
            this.$refs.upload.update(this.editFile.id, {
                error: this.editFile.error || "",
            });
            }
            if (newValue) {
            this.$nextTick(function () {
                if (!this.$refs.editImage) {
                return;
                }
                let cropper = new Cropper(this.$refs.editImage, {
                autoCrop: false,
                });
                this.editFile = {
                ...this.editFile,
                cropper,
                };
            });
            }
        },
        "addData.show"(show) {

            if (show) {
                this.addData.name = "";
                this.addData.type = "";
                this.addData.content = "";
            }
        },*/
    },
    methods: {
        cerrarSubirDocumentos: function(){
            this.$emit("cerrarSubirDocumentos");
        },
      /*subirArchivo: function (archivo) {
        console.log("subirArchivo")
        this.subirArchivoIndividual(archivo)
        //this.$refs.upload.update(archivo, {active: true,error: '',progress: '0.00'})
      },*/
      recargarArchivo: function(archivo){
        console.log("entroaqui")
        /*this.$refs.upload.update(archivo, {
            active: true,
            error: '',
            progress: '0.00',
        })*/
      },
      
      async subirArchivoIndividual(archivo) {
            if (!archivo || archivo.success) return // ya subido o inválido

            const formData = new FormData()
            formData.append("file", archivo.file)

            try {
            const response = await axios.post(this.empresa.linkSubir, formData, {
                headers: {
                "Content-Type": "multipart/form-data",
                ...this.headers
                }
            })

            this.$refs.upload.update(archivo, {
                success: true,
                response: response.data
            })
            } catch (error) {
            console.error("Error al subir archivo:", error)
        this.$refs.upload.update(archivo, {
        error: "Error al subir"
        })
            }
        },
      async subirTodosLosArchivos() {
        this.subidaTodoActiva = true
        for (const archivo of this.archivosSubir) {
            if (archivo.success) continue
            
            let url = `${this.urlBase}/subir_archivos_empresa2/`
            const formData = new FormData()
            formData.append("archivo", archivo.file)

            let infoArchivo = {
                  "idCliente": this.idCliente,
                  "tipoDocumento": this.tipoDocumentoSelected.valor,
                  "mes": this.mesSelected.valor,
                  "anio": this.periodoSelected.valor,
                  "tipoBD": "REMU",
                  "mostrarPeriodo": (this.tipoDocumentoSelected.valor =='contratos') ? this.mostrarPeriodo : true
              }
            formData.append("infoArchivo", JSON.stringify(infoArchivo));

            this.$refs.upload.update(archivo, {
                active: true,
                progress: '0.00'
            })
            axios({
                method: "POST", 
                "url": url,
                data: formData,
                "headers": {
                    'Authorization': this.tokenLogin,
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {

                    if (!archivo._uploadTrack) {
                        archivo._uploadTrack = {
                            lastTime: Date.now(),
                            lastLoaded: 0
                        }
                    }

                    const now = Date.now()
                    const tiempoTranscurrido = (now - archivo._uploadTrack.lastTime) / 1000 // segundos
                    const bytesSubidos = progressEvent.loaded - archivo._uploadTrack.lastLoaded

                    const velocidad = tiempoTranscurrido > 0 ? bytesSubidos / tiempoTranscurrido : 0 // bytes por segundo

                    archivo._uploadTrack.lastTime = now
                    archivo._uploadTrack.lastLoaded = progressEvent.loaded

                    const nuevoProgreso = Math.round((progressEvent.loaded * 100) / progressEvent.total)

                    if (parseFloat(archivo.progress) !== nuevoProgreso) {
                        this.$refs.upload.update(archivo, {
                        progress: nuevoProgreso.toFixed(2),
                        speed: velocidad // bytes/s
                        })
                    }
                    
                    /*const nuevoProgreso = Math.round((progressEvent.loaded * 100) / progressEvent.total)

                    // Solo actualiza si el progreso cambió
                    if (parseFloat(archivo.progress) !== nuevoProgreso) {
                        this.$refs.upload.update(archivo, {
                            progress: nuevoProgreso.toFixed(2),
                            //active: true
                        })
                    }*/
                }
            }).then(result => {
                console.log("result", result)
                this.$refs.upload.update(archivo, {
                    success: true,
                    active: false,
                    response: result.data
                })
            }).catch(error => {
                console.log("error", error)
                this.$refs.upload.update(archivo, {
                    error: error,
                    active: false
                })
            })
            .finally(() => {
                this.subidaTodoActiva = false
            });
        }
    },
    
    validarMensaje: function(archivo){

        if("mensaje" in archivo.response){
            return archivo.response.mensaje.mensaje
        } else {
            return archivo.response.mensaje
        }
    },
      // add, update, remove File event
        inputFile(newFile, oldFile) {
            console.log("newFile", newFile)
            console.log("oldFile", oldFile)
            console.log("archivosSubir", this.archivosSubir)
            /*if (newFile && !oldFile) {
                const yaExiste = this.archivosSubir.some(f => f.name === newFile.name)
                if (!yaExiste) {
                    this.archivosSubir.push(newFile)
                }
            }*/
        
          if (newFile && oldFile) {
              // update
              
              if (newFile.active && !oldFile.active) {
              // beforeSend
              // min size
              if (
                  newFile.size >= 0 &&
                  this.minSize > 0 &&
                  newFile.size < this.minSize
              ) {
              
                  this.$refs.upload.update(newFile, { error: "size" });
              }
              }
              if (newFile.progress !== oldFile.progress) {
              // progress
              
              }
              if (newFile.error && !oldFile.error) {
              // error
              }
              if (newFile.success && !oldFile.success) {
              // success
                  this.empresasFiltradas.forEach(empresa => {
                      if(newFile.response.idEmpresa == empresa.idEmpresa){
                          let haySinTerminar = false
                          empresa.archivosSubir.forEach(archivo =>{
                              if(archivo.active)
                                  haySinTerminar = true
                              
                          })
                          if(!haySinTerminar){
                              this.getTrabajadoresInfoEmpresa(true, empresa)
                          }
                      }
                  })
              
              }
          }
          if (!newFile && oldFile) {
              // remove
              if (oldFile.success && oldFile.response.id) {
              // $.ajax({
              //   type: 'DELETE',
              //   url: '/upload/delete?id=' + oldFile.response.id,
              // })
              }
          }
          // Automatically activate upload
          if (
              Boolean(newFile) !== Boolean(oldFile) ||
              oldFile.error !== newFile.error
          ) {
              //if (this.uploadAuto && !this.$refs.upload.active) {
              //this.$refs.upload.active = true;
              //}
          }
          this.$forceUpdate()
      },
      /*alert(message) {
          alert(message);
      },
      onAddData() {
          this.addData.show = false;
          if (!this.$refs.upload.features.html5) {
              this.alert("Your browser does not support");
              return;
          }
          let file = new window.File([this.addData.content], this.addData.name, {
              type: this.addData.type,
          });
          this.$refs.upload.add(file);
      },*/
    }
}
</script> 

<style>
.btn-margen{
  margin-top: 5px;
  margin-bottom: 5px;
}
.center-content {
    display: flex;
    justify-content: center; /* Centra horizontalmente */
    align-items: center; /* Centra verticalmente */
    height: 100%; /* Asegúrate de que haya espacio suficiente */
}
</style>